// extracted by mini-css-extract-plugin
export var headingWrapper = "plansv2-module--heading-wrapper--1I3P9";
export var darkGradient = "plansv2-module--dark-gradient--3Ahib";
export var darkBlue = "plansv2-module--dark-blue--3wxVY";
export var white = "plansv2-module--white--39TEN";
export var cta = "plansv2-module--cta--2E2Jw";
export var study = "plansv2-module--study--IoGRM";
export var studyCopyContainer = "plansv2-module--study-copy-container--P0DT5";
export var studyCopy = "plansv2-module--study-copy--33fP1";
export var copyImage = "plansv2-module--copy-image--2L1hp";
export var footer = "plansv2-module--footer--2QujU";
export var heading = "plansv2-module--heading--7Iggv";
export var lede = "plansv2-module--lede--24Ldg";